import { Crown, Link2, Loader2, Play, RefreshCw, WifiOff } from "lucide-react";

const MODES = {
  host: { icon: Crown, label: "Hosting · everyone follows you", tone: "text-gold" },
  synced: { icon: Link2, label: "Synced with host", tone: "text-emerald-300" },
  "catching-up": { icon: Loader2, label: "Catching up to host…", tone: "text-gold", spin: true },
  "host-away": { icon: WifiOff, label: "Host is away — playing freely", tone: "text-foreground/70" },
  waiting: { icon: Loader2, label: "Waiting for host to start", tone: "text-foreground/70" },
  detached: { icon: Link2, label: "Watching on your own", tone: "text-foreground/70" },
  reconnecting: { icon: Loader2, label: "Reconnecting sync…", tone: "text-foreground/70", spin: true },
  "no-socket": { icon: WifiOff, label: "Sync unavailable on this network", tone: "text-red-300" },
};

export const SyncStatus = ({ sync }) => {
  const m = MODES[sync.mode];
  const Icon = m.icon;
  return (
    <div className="absolute top-3 left-3 z-20 flex items-center gap-2" data-testid="wp-sync-status" data-mode={sync.mode}>
      <span className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-black/60 backdrop-blur border border-white/15 text-[11px] font-medium ${m.tone}`}>
        <Icon className={`w-3 h-3 ${m.spin ? "animate-spin" : ""}`} /> {m.label}
        {(sync.mode === "synced" || sync.mode === "catching-up") && (
          <span className="text-foreground/50 tabular-nums" data-testid="wp-sync-drift">±{Math.abs(sync.drift).toFixed(1)}s</span>
        )}
      </span>
      {sync.mode === "detached" && (
        <button
          type="button"
          onClick={sync.resync}
          className="flex items-center gap-1 px-2.5 py-1 rounded-full bg-terracotta hover:bg-ember text-white text-[11px] font-semibold transition-colors"
          data-testid="wp-resync-btn"
        >
          <RefreshCw className="w-3 h-3" /> Re-sync to host
        </button>
      )}
    </div>
  );
};

export const TapToJoin = ({ onTap, isHost }) => (
  <button
    type="button"
    onClick={onTap}
    className="absolute inset-0 z-30 flex flex-col items-center justify-center gap-3 bg-black/55 backdrop-blur-sm text-white"
    data-testid="wp-tap-to-join"
  >
    <span className="w-16 h-16 rounded-full bg-terracotta flex items-center justify-center shadow-xl transition-transform hover:scale-105">
      <Play className="w-7 h-7 ml-1" fill="currentColor" />
    </span>
    <span className="text-sm font-semibold">{isHost ? "Tap to resume the party" : "Tap to join the host"}</span>
  </button>
);
